import { forwardRef } from "react";
import * as s from "./DetailHeaderStyled";

type Props = {
  infos: { label: string; value: React.ReactNode; onClick?: () => void }[];
  buttons?: React.ReactNode;
};
function DetailHeader(props: Props, ref: React.Ref<HTMLDivElement>) {
  return (
    <s.Top>
      <s.Header>
        {props.infos.map((item, index) => {
          return (
            <s.HeaderItem key={`top-info-${index}`}>
              <h3>{item.label}</h3>
              <p
                onClick={item.onClick}
                data-testid="blocks-subheader-p-click"
              >
                {item.value}
              </p>
            </s.HeaderItem>
          );
        })}
      </s.Header>

      {props.buttons}
    </s.Top>
  );
}

export default forwardRef(DetailHeader);
